/**
 * ONE 플랫폼 사용 로그 (StoreCAD)
 *
 * "누가 무엇을 얼마나 쓰는지"를 남긴다. 화면 내용이나 도면 데이터는 절대 담지 않고,
 * 어떤 화면을 열었는지 수준만 기록한다.
 *
 * · 실패해도 화면 동작을 막지 않는다 — 로그는 부가 기능이다.
 * · 사용자 이메일은 서버(log_usage RPC)가 채운다 — 클라이언트가 남의 이름을 못 쓴다.
 * · 같은 동작이 연달아 들어오면 한 번만 남긴다(리렌더로 도배되는 걸 막는다).
 */
import { isDevPreview } from '../boot/devPreview';
import { sb } from './supabase';

const SYSTEM_KEY = 'cad';
const SESSION_KEY = 'onePlatformUsageSession';

let lastKey = '';
let lastAt = 0;

/** 같은 방문(탭이 살아 있는 동안)을 하나로 묶는 값 */
function sessionId(): string | null {
  try {
    let s = sessionStorage.getItem(SESSION_KEY);
    if (!s) {
      s = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      sessionStorage.setItem(SESSION_KEY, s);
    }
    return s;
  } catch {
    return null;   // 프라이빗 모드 등 — 없어도 기록은 남는다
  }
}

export function trackUsage(action: string, detail?: string): void {
  if (isDevPreview()) return;

  const key = `${action}|${detail ?? ''}`;
  const now = Date.now();
  if (key === lastKey && now - lastAt < 3000) return;
  lastKey = key;
  lastAt = now;

  try {
    void sb()
      .rpc('log_usage', {
        p_system_key: SYSTEM_KEY,
        p_action: action,
        p_detail: detail ? detail.slice(0, 200) : null,
        p_session_id: sessionId(),
      })
      .then(({ error }) => {
        // 함수가 아직 없으면(SQL 미실행) 조용히 넘어간다.
        if (error) console.debug('[usage] 기록 실패(무시):', error.message);
      });
  } catch {
    /* 무시 */
  }
}
